const ChartTypes = Object.freeze({
  HEATMAP: 'heatmap',
  BAR: 'bar',
  SCATTER: 'scatter',
  TRACKING: 'tracking',
  STRIKE_ZONE: 'strike_zone',
});

export { ChartTypes };
